import { $service } from '@xt/client/experimental/request/service'
import $global from '@xt/client/store/global'

import type { BookConfig, PlatformConfigSuffix } from '@xt/client/types/book.d'

class BookManager {
  private cache: Map<string, BookConfig>

  private bookImgData: Map<string, string[]> = new Map()

  constructor() {
    this.cache = new Map()
  }

  async getBook(jsonFileName: `${string}-${PlatformConfigSuffix}.json`) {
    if (this.cache.has(jsonFileName)) {
      return this.cache.get(jsonFileName)!
    }

    const [error, dataSource] = await $service<BookConfig>({
      method: 'GET',
      url: `/mocks/${jsonFileName}`,
      baseURL: $global.production ? 'https://static.xuantong.cn' : 'https://testing-static.xuantong.cn'
    })

    if (error) {
      return null
    }

    this.cache.set(jsonFileName, dataSource)
    return dataSource
  }

  // 批量获取
  async batchMapRealUrl(): Promise<string[]> {
    return []
  }

  // 根据书名获取加密图片url
  async getBookImgDataByName(file: string) {
    if (!this.bookImgData.has(file)) {
      // 获取加密图片数据
      const res = await this.batchMapRealUrl()

      if (!res.length) return

      this.bookImgData.set(file, res)
    }
    return this.bookImgData.get(file)
  }

  /**
   * @return 返回一个数组，包含start到end的图片url，部分数据为空
   * 判断是否有缓存数据，从 bookImgData 获取
   */
  getRealUrlByRange(imgList: string[], start: number, end: number) {
    return []
  }

  // 重置滚动指针
  public resetKey() {}

  // 离开页面，清空缓存
  public cleanData() {}
}

const bookManager = new BookManager()

export default bookManager
